export default "__VITE_ASSET__q3R_gLBT__"